var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 4)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#6B6B6B",
    cx: 10.167,
    cy: 12.433,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77 13.985l1.243-1.554H8.67a.645.645 0 01-.504-1.047L9.77 9.381a.46.46 0 11.719.575L9.245 11.51h2.343a.645.645 0 01.503 1.048l-1.602 2.003a.46.46 0 11-.72-.576z",
    stroke: "#FFF",
    strokeWidth: 0.01,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.368 15.654a4.596 4.596 0 01-1.843-3.683H.921v2.762c0 .509.412.921.92.921h5.527zm2.761.919v.002H1.842A1.842 1.842 0 010 14.733V1.842C0 .825.825 0 1.842 0h8.287c1.017 0 1.842.825 1.842 1.842V7.75a4.604 4.604 0 01-1.842 8.823zm.921-9.114V1.842a.92.92 0 00-.92-.921H1.841a.92.92 0 00-.921.92v3.684H11.05v.92H.92v4.605h4.697a4.605 4.605 0 015.433-3.591zM3.223 4.144a.92.92 0 110-1.842.92.92 0 010 1.842zm0 5.525a.92.92 0 110-1.842.92.92 0 010 1.842zm0 5.064a.92.92 0 110-1.841.92.92 0 010 1.841zm6.905.92a3.682 3.682 0 100-7.366 3.682 3.682 0 000 7.365z",
    fill: "#666",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.01
  }))));
}
export default SvgCharging;